import { CustomHeaderComponent } from '../../components/custom-header/custom-header.component';
import { MapperTypesComponent } from '../../components/mapper-types/mapper-types.component';
import { MAPPER_CONFIGS } from '../../components/mapper-types/model/mappers.model';
import { INTEGRATIONS } from '../global-configuration.constant';
import { NexsysDefaultSettingComponent } from '../../nexsys-mapper-types/nexsys-default-setting/nexsys-default-setting.component';
import { NexsysOrderMessageLoaderService } from '../../service/nexsys-order-message-loader.service';
import { DefaultSettingLoaderService } from '../../service/default-setting-loader.service';
import { DocumentTypesLoaderService } from '../../service/document-types.loader.service';
import { LoanReasonsLoaderService } from '../../service/loan-reasons-loader.service';
import { LoanTypesLoaderService } from '../../service/loan-types-loader.service';
import { OccupancyTypesLoaderService } from '../../service/occupancy-types-loader.service';
import { PropertyTypesLoaderService } from '../../service/property-types-loader.service';
import { MessagesComponent } from '../../components/messages/messages.component';

const NEXSYS_MAPPER_CHILDREN = [
	{
		path: 'property-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.NEXSYS,
			config: MAPPER_CONFIGS.PROPERTY_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Property Types'
			},
		},
		canActivate: [PropertyTypesLoaderService]
	},
	{
		path: 'loan-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.NEXSYS,
			config: MAPPER_CONFIGS.LOAN_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Loan Types'
			},
		},
		canActivate: [LoanTypesLoaderService]
	},
	{
		path: 'loan-reasons',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.NEXSYS,
			config: MAPPER_CONFIGS.LOAN_REASONS,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Loan Reasons'
			}
		},
		canActivate: [LoanReasonsLoaderService]
	},
	{
		path: 'occupancy-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.NEXSYS,
			config: MAPPER_CONFIGS.OCCUPANCY_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Occupancy Types'
			}
		},
		canActivate: [OccupancyTypesLoaderService]
	},
	{
		path: 'on-hold-reasons',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.NEXSYS,
			config: MAPPER_CONFIGS.ONHOLD_REASONS,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'OnHold Reasons'
			}
		}
	},
	{
		path: 'document-types',
		component: MapperTypesComponent,
		data: {
			entity: INTEGRATIONS.NEXSYS_DOCUMENT_TYPES,
			config: MAPPER_CONFIGS.DOCUMENT_TYPES,
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Document Types'
			}
		},
		canActivate: [DocumentTypesLoaderService]
	},
	{
		path: 'lender-company-message',
		component: MessagesComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Lender Company Messages Configuration'
			}
		}
	},
	{
		path: 'milestone-message',
		component: MessagesComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Nexsys Order Messages Configuration'
			}
		},
		canActivate: [NexsysOrderMessageLoaderService]
	},
	{
		path: 'assets-on-completion',
		component: MessagesComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Assets On Completion'
			}
		}
	},

	{
		path: 'data-message-type',
		component: MessagesComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Data Message Type Configuration'
			}
		}
	},
	{
		path: 'default-settings',
		component: NexsysDefaultSettingComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Default Settings'
			}
		},
		canActivate: [DefaultSettingLoaderService]
	}
];

export const NEXSYS_MAPPER = [
	{
		path: 'nexsys-mapper-types',
		pathMatch: 'prefix',
		children: NEXSYS_MAPPER_CHILDREN
	}
]
